import { AppCategory } from '../types';

export const categoryDisplayNames: Record<AppCategory, string> = {
  'ai-tools': 'Smart AI Apps',
  'client-tools': 'For Clients',
  'internal': 'Team Tools',
  'mcp-servers': 'Connectors',
  'automation': 'Auto Tasks'
};

export const getCategoryDisplayName = (category: AppCategory): string => {
  return categoryDisplayNames[category];
};
